export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const websiteId = String(config.public.umamiWebsiteId || '')
  const umamiUrl = String(config.public.umamiUrl || '').replace(/\/$/, '')

  if (!import.meta.env.PROD || !websiteId || !umamiUrl) return
  if (document.querySelector<HTMLScriptElement>('script[data-descontito-umami="true"]')) return

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `${umamiUrl}/script.js`
  script.setAttribute('data-website-id', websiteId)
  script.setAttribute('data-domains', 'descontito.com.br,www.descontito.com.br')
  script.setAttribute('data-do-not-track', 'true')
  script.setAttribute('data-performance', 'true')
  script.setAttribute('data-descontito-umami', 'true')
  script.addEventListener('load', () => {
    const queue = window.__descontitoUmamiQueue ?? []
    window.__descontitoUmamiQueue = []

    for (const item of queue) {
      if (item.type === 'track') {
        window.umami?.track(item.name, item.data)
      }
      else {
        window.umami?.identify(item.id, item.data)
      }
    }
  })
  document.head.appendChild(script)
})
